module.exports = __webpack_public_path__ + "img/car-sdf.65989753.svg";